import api from "../utils/api";

export const createAdmin = async (formData) => {
  try {
    const response = await api.post("/admin", formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAdminById = async (adminId) => {
  try {
    const response = await api.get(`/admin/${adminId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAdminByEmail = async (email) => {
  try {
    const response = await api.get(`/admin/loginWithEmail/${email}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllAdmins = async () => {
  try {
    const response = await api.get("/admin");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateAdmin = async (adminId, formData) => {
  try {
    const response = await api.put(`/admin/${adminId}`, formData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteAdmin = async (adminId) => {
  try {
    const response = await api.delete(`/admin/${adminId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
